import axios from 'axios';
const chartReducer=function(state={chart:{},chartType:{}},action){
    switch(action.type){
        case "GET_CHART_DATA":
        return {...state,chart:{...action.payload}}
        case "SET_CHART_TYPE":
        return {...state,chartType:action.payload}  
        default:
        return state;
    }
}
export default chartReducer;